import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { FlyFreelyFormlyModule } from '@flyfreely-portal-ui/flyfreely-formly';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { ToastrModule } from 'ngx-toastr';
import { FlightConformancePolicy } from './flight-conformance-policy.component';
import { FlightConformanceSetup } from './flight-conformance-setup.component';
import { FormatConformanceRuleSettingsPipe } from './formatConformanceRuleSettings.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TooltipModule,
        ReactiveFormsModule,
        NgSelectModule,
        ButtonsModule,
        NgxLoadingModule,
        ToastrModule,
        FormlyModule,
        FormlyBootstrapModule,
        FlyFreelyFormlyModule,
        EnhancedHelpModule,
        AnalyticsModule,
        LoadingIndicatorModule,
        ValidationModule,
        SharedUiModule
    ],
    declarations: [
        FlightConformanceSetup,
        FormatConformanceRuleSettingsPipe,
        FlightConformancePolicy
    ],
    exports: [FlightConformanceSetup]
})
export class FlightConformanceModule {}
